module.exports = __webpack_public_path__ + "img/mortgage.cd403d5.svg";